import { inputAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";
import { layerStyles } from "theme/layer-styles";

export const selectTheme = createMultiStyleConfigHelpers(
  inputAnatomy.keys,
).defineMultiStyleConfig({
  variants: {
    outline: {
      field: {
        ...layerStyles["input-container"],
      },
    },
  },
  sizes: {
    md: {
      field: {
        px: "2.5",
      },
    },
  },
});
